module.exports = __webpack_public_path__ + "static/media/Grab-Your-Popcorn-I---Pretty-Woman.3adf68e1.jpg";